import { Stack } from '@chakra-ui/react'
import { queryClient } from '@scout/identity'
import { Provider } from '@scout/ui'
import { AppShell } from '@scout/ui/shell'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRootRoute, Outlet } from '@tanstack/react-router'

import { BriefsLink } from '@/features/brief/BriefsLink'
import { Identity } from '@/features/identity/Identity'
import { VendorsLink } from '@/features/vendor/VendorsLink'

// Hoisted: JSX literals in props are new elements on every render.
//
// Each decides for itself whether there is anything to show: the shell is a
// layout and has no business knowing who is signed in. That is why this is a
// stack of two rather than a list built from who somebody is — the sidebar has
// no idea, and neither does the shell holding it.
const nav = (
  <Stack gap="0.5" align="stretch">
    <BriefsLink />
    <VendorsLink />
  </Stack>
)
const identity = <Identity />

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  return (
    <Provider>
      <QueryClientProvider client={queryClient}>
        <AppShell sidebarNav={nav} sidebarFooter={identity}>
          <Outlet />
        </AppShell>
      </QueryClientProvider>
    </Provider>
  )
}
